import resultPDFService from '../../api/resultsPDF'
import notify from '../../api/notification'
import { downloadFileByByteArray } from '@/utils/convertByteArrayToFile'
import { printFileByByteArray } from '@/utils/convertByteArrayToPrint'
import strings from '@/strings'
import { PDFDocument } from 'pdf-lib'
import Moment from 'moment'

const state = {
  resultsPdfLoadingStatus: false,
  resultsPdfFilters: {},
  resultsPdfList: {},
  resultsSelectedOrders: [],
  htmlForDownload: null,
  resultsPdfDownloadModalStatus: false,
  listHTMLForDownload: [],
  allResultsModalStatus: false,
  resultsPdfDownloadLoading: false,
  listOfOSsForDownload: [],
  resultToExportInPDF: {},
  mnemonicsToExportInPDF: [],
  printConfig: {
    margem_superior: 0,
    logo: true,
    mat: true,
    sexo: true,
    idd: 'nenhum',
    iddext: true,
    docp: true,
    ins: true,
    lis: false,
    sol: false,
    nomeInstituicao: 'fantasia',
    liberadoEm: false,
    ref: false,
    sep: false,
    minf: 100,
    lib: true,
    ass: false,
    obsa: true,
    mostrarQrCode: false,
    rodape: 'sim'
  }
}

const mutations = {
  setResultPdfSetLoadingStatus(state, resultsPdfLoadingStatus) {
    state.resultsPdfLoadingStatus = resultsPdfLoadingStatus
  },
  setResultPdfResultsList(state, resultsPdfList) {
    state.resultsPdfList = resultsPdfList
  },
  setSelectedOrders(state, resultsSelectedOrders) {
    state.resultsSelectedOrders = resultsSelectedOrders
  },
  setResultsPdfFilters(state, resultsPdfFilters) {
    state.resultsPdfFilters = resultsPdfFilters
  },
  setHTMLForDownload(state, htmlForDownload) {
    state.htmlForDownload = htmlForDownload
  },
  setResultsPdfModalStatus(state, resultsPdfDownloadModalStatus) {
    state.resultsPdfDownloadModalStatus = resultsPdfDownloadModalStatus
  },
  setListHTMLForDownload(state, listHTMLForDownload) {
    state.listHTMLForDownload = listHTMLForDownload
  },
  setAllResultsModalStatus(state, allResultsModalStatus) {
    state.allResultsModalStatus = allResultsModalStatus
  },
  setResultsPdfDownloadLoading(state, resultsPdfDownloadLoading) {
    state.resultsPdfDownloadLoading = resultsPdfDownloadLoading
  },
  setListOfOSsForDownload(state, listOfOSsForDownload) {
    state.listOfOSsForDownload = listOfOSsForDownload
  },
  setResultToExportInPDF(state, result) {
    state.resultToExportInPDF = result
  },
  setMnemonicsToExportInPDF(state, mnemonics) {
    state.mnemonicsToExportInPDF = mnemonics
  },
  setPrintConfig(state, printConfig) {
    state.printConfig = printConfig
  }
}

const getters = {
  resultsPdfLoadingStatus: state => {
    return state.resultsPdfLoadingStatus
  },
  resultsPdfList: state => {
    return state.resultsPdfList
  },
  resultsPdfFilters: state => {
    return state.resultsPdfFilters
  },
  resultsSelectedOrders: state => {
    return state.resultsSelectedOrders
  },
  htmlForDownload: state => {
    return state.htmlForDownload
  },
  resultsPdfDownloadModalStatus: state => {
    return state.resultsPdfDownloadModalStatus
  },
  listHTMLForDownload: state => {
    return state.listHTMLForDownload
  },
  listPDFForDownload: state => {
    return state.listPDFForDownload
  },
  allResultsModalStatus: state => {
    return state.allResultsModalStatus
  },
  resultsPdfDownloadLoading: state => {
    return state.resultsPdfDownloadLoading
  },
  listOfOSsForDownload: state => {
    return state.listOfOSsForDownload
  },
  printConfig: state => {
    return state.printConfig
  }
}

const actions = {
  getServiceResultsPDF: function ({ commit, state }) {
    commit('setResultPdfSetLoadingStatus', true)
    commit('setSelectedOrders', [])

    return resultPDFService
      .getResultsPDFByFilter(state.resultsPdfFilters)
      .then(response => {
        commit('setResultPdfSetLoadingStatus', false)
        commit('setResultPdfResultsList', response.data)
      })
      .catch(err => {
        let message = err.response.data.message
        if (!message || !message.includes('Acesso bloqueado')) {
          message = 'Não foi possível carregar os resultados.'
        }

        notify({
          title: 'AVISO:',
          message: message
        })

        commit('setResultPdfResultsList', [])
        commit('setResultPdfSetLoadingStatus', false)
      })
  },
  getSelectedOrders: function ({ commit }, orders) {
    commit('setSelectedOrders', orders)
  },
  getResultsPDFFilter: function ({ commit }, filters) {
    commit('setResultsPdfFilters', filters)
  },
  exportPatientResultsInHTML: function ({ commit, state, dispatch }, result) {
    commit('setResultsPdfDownloadLoading', true)
    const exams = result.examResultDateResponseList.filter(exam =>
      state.resultsSelectedOrders.includes(exam.idItemExam)
    )
    const mnemonics = exams.map(exam => exam.mnemonic)
    commit('setResultToExportInPDF', result)
    commit('setMnemonicsToExportInPDF', mnemonics)

    return resultPDFService
      .downloadResultsHTML(result.alvaroId, mnemonics)
      .then(response => {
        dispatch('setExamMomentlyAsReaded', { alvaroId: result.alvaroId, orders: exams })
        commit('setHTMLForDownload', response.data)
        commit('setResultsPdfModalStatus', true)
        commit('setResultsPdfDownloadLoading', false)
      })
      .catch(() => {
        commit('setResultsPdfDownloadLoading', false)
        notify({
          title: 'AVISO:',
          message: strings.resultsPDFErrorsMessages.downloadFail
        })
      })
  },
  exportAllResultsInHTML: async function ({ commit, state, dispatch }) {
    if (state.resultsSelectedOrders.length > 0) {
      commit('setResultsPdfDownloadLoading', true)

      const filteredOSs = state.resultsPdfList.orders.filter(order => {
        return order.examResultDateResponseList.some(exam => state.resultsSelectedOrders.includes(exam.idItemExam))
      })

      const osArray = filteredOSs.map(os => {
        return {
          id: os.alvaroId,
          mnemonics: os.examResultDateResponseList.map(exam => exam.mnemonic)
        }
      })

      commit('setListOfOSsForDownload', osArray)

      let arrayOfHTML = []
      let osError = []
      try {
        const downloadPromises = osArray.map(async order => {
          try {
            const response = await resultPDFService.downloadResultsHTML(order.id, order.mnemonics)
            dispatch('setExamMomentlyAsReaded', { alvaroId: order.id, orders: filteredOSs })
            arrayOfHTML.push(response.data)
          } catch (error) {
            osError.push(order.id)
          }
        })

        await Promise.all(downloadPromises)

        if (osError.length > 0) {
          notify({
            title: 'AVISO:',
            message: `Erro ao visualizar as seguintes OS(s): `.concat(osError.join(', '))
          })
        }

        const finalHTML = arrayOfHTML.join('<div style="page-break-before: always;"></div>')

        commit('setListHTMLForDownload', finalHTML)
        commit('setAllResultsModalStatus', true)
        commit('setResultsPdfDownloadLoading', false)
        commit('setSelectedOrders', [])
      } catch (error) {
        commit('setResultsPdfDownloadLoading', false)
        notify({
          title: 'AVISO:',
          message: `Erro ao visualizar os exames. Por favor, tente novamente.`
        })
      }
    } else {
      notify({
        title: 'AVISO:',
        message: 'Selecione pelo menos 1 OS que tenha resultados disponíveis.'
      })
    }
  },
  changeStatusResultsPdfModal: function ({ commit }, status) {
    commit('setResultsPdfModalStatus', status)
  },
  changeAllResultsModalStatus: function ({ commit }, status) {
    commit('setAllResultsModalStatus', status)
  },
  exportAllResultToPrint: async function ({ commit, state }) {
    commit('setResultsPdfDownloadLoading', true)
    let osError = []
    try {
      const pdfDoc = await PDFDocument.create()
      for (const order of state.listOfOSsForDownload) {
        try {
          const response = await resultPDFService.downloadResultsPDF(order.id, order.mnemonics)
          const pdfBuffer = await response.data
          const pdf = await PDFDocument.load(pdfBuffer)
          const copiedPages = await pdfDoc.copyPages(pdf, pdf.getPageIndices())
          copiedPages.forEach(page => pdfDoc.addPage(page))
        } catch (error) {
          osError.push(order.id)
        }
      }

      const pdfBytes = await pdfDoc.save()
      const fileExtension = 'application/pdf'
      printFileByByteArray(pdfBytes, fileExtension)

      if (osError.length > 0) {
        notify({
          title: 'AVISO:',
          message: `Erro ao visualizar as seguintes OS(s):`.concat(osError.join(', '))
        })
      }

      commit('setResultsPdfDownloadLoading', false)
      commit('setSelectedOrders', [])
      commit('setListOfOSsForDownload', [])
    } catch (error) {
      console.error('Erro ao processar os PDFs:', error)
      commit('setResultsPdfDownloadLoading', false)
      notify({
        title: 'AVISO:',
        message: `Erro ao visualizar os exames. Por favor, tente novamente.`
      })
    }
  },
  exportAllResultsInPDF: async function ({ commit, state }) {
    commit('setResultsPdfDownloadLoading', true)
    try {
      const pdfDoc = await PDFDocument.create()
      let osError = []
      for (const order of state.listOfOSsForDownload) {
        try {
          const response = await resultPDFService.downloadResultsPDF(order.id, order.mnemonics)
          const pdfBuffer = await response.data
          const pdf = await PDFDocument.load(pdfBuffer)
          const copiedPages = await pdfDoc.copyPages(pdf, pdf.getPageIndices())
          copiedPages.forEach(page => pdfDoc.addPage(page))
        } catch (error) {
          osError.push(order.id)
        }
      }

      if (osError.length > 0) {
        notify({
          title: 'AVISO:',
          message: `Erro ao visualizar as seguintes OS(s): `.concat(osError.join(', '))
        })
      }

      const pdfBytes = await pdfDoc.save()
      const fileName = 'Laudos Alvaro - ' + Moment(new Date()).format('DD/MM/YYYY')
      const fileExtension = 'application/pdf'
      downloadFileByByteArray(pdfBytes, fileName, fileExtension)

      commit('setResultsPdfDownloadLoading', false)
      commit('setSelectedOrders', [])
      commit('setListOfOSsForDownload', [])
    } catch (error) {
      console.error('Erro ao processar os PDFs:', error)
      commit('setResultsPdfDownloadLoading', false)
      notify({
        title: 'AVISO:',
        message: `Erro ao visualizar os exames. Por favor, tente novamente.`
      })
    }
  },
  viewAllResultsInPDF: async function ({ commit, state, dispatch }) {
    if (state.resultsSelectedOrders.length > 0) {
      commit('setResultsPdfDownloadLoading', true)

      const filteredOSs = state.resultsPdfList.orders.filter(order => {
        return order.examResultDateResponseList.some(
          exam => state.resultsSelectedOrders.includes(exam.idItemExam))
      })

      const osArray = filteredOSs.map(os => {
        const exams = os.examResultDateResponseList.filter(exam =>
          state.resultsSelectedOrders.includes(exam.idItemExam)
        )
        return {
          id: os.alvaroId,
          mnemonics: exams.map(exam => exam.mnemonic)
        }
      })

      try {
        const pdfDoc = await PDFDocument.create()
        let osError = []
        const downloadPromises = osArray.map(async order => {
          try {
            const response = await resultPDFService.downloadResultsPDF(order.id, order.mnemonics)
            const pdfBuffer = await response.data
            const pdf = await PDFDocument.load(pdfBuffer)
            const copiedPages = await pdfDoc.copyPages(pdf, pdf.getPageIndices())
            copiedPages.forEach(page => pdfDoc.addPage(page))
            dispatch('setExamMomentlyAsReaded', { alvaroId: order.id, orders: filteredOSs })
          } catch (error) {
            osError.push(order.id)
          }
        })

        await Promise.all(downloadPromises)

        if (osError.length > 0) {
          notify({
            title: 'AVISO:',
            message: `Erro ao visualizar as seguintes OS(s): `.concat(osError.join(', '))
          })
        }

        const pdfBytes = await pdfDoc.save()
        console.info(pdfBytes)

        commit('setHTMLForDownload', pdfBytes)
        commit('setResultsPdfModalStatus', true)
        commit('setResultsPdfDownloadLoading', false)
        commit('setSelectedOrders', [])
        commit('setListOfOSsForDownload', [])
      } catch (error) {
        console.error('Erro ao processar os PDFs:', error)
        commit('setResultsPdfDownloadLoading', false)
        notify({
          title: 'AVISO:',
          message: `Erro ao visualizar os exames. Por favor, tente novamente.`
        })
      }
    }
  },
  exportResultToPrint: async function ({ commit, state }) {
    commit('setResultsPdfDownloadLoading', true)
    try {
      const response = await resultPDFService.downloadResultsPDF(
        state.resultToExportInPDF.alvaroId,
        state.mnemonicsToExportInPDF
      )
      const fileExtension = 'application/pdf'
      printFileByByteArray(response.data, fileExtension)
      commit('setResultsPdfDownloadLoading', false)
      commit('setResultToExportInPDF', {})
      commit('setMnemonicsToExportInPDF', [])
    } catch (error) {
      console.error('Erro ao processar o PDF:', error)
      commit('setResultsPdfDownloadLoading', false)
      notify({
        title: 'AVISO:',
        message: `Erro ao fazer download do PDF. Por favor, tente novamente.`
      })
    }
  },
  exportResultInPDF: async function ({ commit, state }) {
    commit('setResultsPdfDownloadLoading', true)
    try {
      const response = await resultPDFService.downloadResultsPDF(
        state.resultToExportInPDF.alvaroId,
        state.mnemonicsToExportInPDF
      )
      const fileName = state.resultToExportInPDF.alvaroId
      const fileExtension = 'application/pdf'
      downloadFileByByteArray(response.data, fileName, fileExtension)
      commit('setResultsPdfDownloadLoading', false)
      commit('setResultToExportInPDF', {})
      commit('setMnemonicsToExportInPDF', [])
    } catch (error) {
      console.error('Erro ao processar o PDF:', error)
      commit('setResultsPdfDownloadLoading', false)
      notify({
        title: 'AVISO:',
        message: `Erro ao fazer download do PDF. Por favor, tente novamente.`
      })
    }
  },
  viewResultInPDF: async function ({ commit, state, dispatch }, result) {
    commit('setResultsPdfDownloadLoading', true)
    try {
      const exams = result.examResultDateResponseList.filter(exam =>
        state.resultsSelectedOrders.includes(exam.idItemExam)
      )
      const mnemonics = exams.map(exam => exam.mnemonic)
      commit('setResultToExportInPDF', result)

      const response = await resultPDFService.downloadResultsPDF(result.alvaroId, mnemonics)

      console.info(response.data)

      dispatch('setExamMomentlyAsReaded', { alvaroId: result.alvaroId, orders: exams })
      commit('setHTMLForDownload', response.data)
      commit('setResultsPdfModalStatus', true)
      commit('setResultsPdfDownloadLoading', false)
    } catch (error) {
      console.error('Erro ao processar o PDF:', error)
      commit('setResultsPdfDownloadLoading', false)
      notify({
        title: 'AVISO:',
        message: `Erro ao fazer download do PDF. Por favor, tente novamente.`
      })
    }
  },
  getPrintConfig: async function ({ commit }) {
    try {
      const response = await resultPDFService.getPrintConfig()
      commit('setPrintConfig', response.data)
    } catch (error) {
      console.error('Erro ao Buscar as configurações de impressão:', error)
    }
  },
  setExamMomentlyAsReaded: function ({ commit, state }, osData) {
    const list = state.resultsPdfList

    const examsIdsArray = osData.orders.flatMap(exam => {
      if (exam.examResultDateResponseList) {
        return exam.examResultDateResponseList.map(id => id.idItemExam)
      } else {
        return [exam.idItemExam]
      }
    })

    for (let i = 0; i < list.orders.length; i++) {
      if (list.orders[i].alvaroId === osData.alvaroId) {
        const examResultDateResponseList = list.orders[i].examResultDateResponseList
        for (let j = 0; j < examResultDateResponseList.length; j++) {
          if (examResultDateResponseList[j].status === 'READY') {
            if (examsIdsArray.length > 0) {
              if (
                examsIdsArray.includes(examResultDateResponseList[j].idItemExam) &&
                !examResultDateResponseList[j].generatedInternetDate
              ) {
                examResultDateResponseList[j].generatedInternetDate = Moment().format('DD/MM/YYYY')
                list.orders[i].amountReaded++
                list.orders[i].amountReady--
              }
            } else {
              if (!examResultDateResponseList[j].generatedInternetDate) {
                examResultDateResponseList[j].generatedInternetDate = Moment().format('DD/MM/YYYY')
                list.orders[i].amountReaded++
                list.orders[i].amountReady--
              }
            }
          }
        }
      }
    }

    commit('setResultPdfResultsList', list)
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
